<!--
//================================================================================
// ID:-
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:FileUpload
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/08/06 | 富士通株式会社         | 新規作成
//================================================================================
-->
<template>
	<div class="div-item--upload" :class="[classDiv != '' ? classDiv : '']">
		<div :class="'div-item--upload__area--float'">
			<text-input
				:class="['contents__input--text', {'contents__error--item': errorFlg}]"
				:modelValue="fileName"
				:name="name"
				:disabledFlg="true"
				:placeholder="placeholder"
				:requireFlg="requireFlg"
				:tabindex="tabindex"
				@update:modelValue="fileName = $event"
			/>
		</div>
		<div class="div-item--upload__area--float">
			<input
				type="submit"
				value="選択"
				ref="addBtn"
				class="contents__btn--normal contents__btn margin-select-btn"
				:tabindex="Number(tabindex) <= 0 ? tabindex:String(Number(tabindex) + 1)"
				@click="clickAddBtn"
			>
			<input
				type="submit"
				value="解除"
				class="contents__btn--cancel contents__btn"
				:tabindex="Number(tabindex) <= 0 ? tabindex:String(Number(tabindex) + 1)"
				@click="clickDelBtn"
			>
			<input
				type="submit"
				value="取込み"
				class="contents__btn--confirm contents__btn contents__btn--torikomi"
				:tabindex="Number(tabindex) <= 0 ? tabindex:String(Number(tabindex) + 1)"
				v-on:click="clickUploadOrSaveBtn"
			>
			<input
				style="display: none"
				ref="inputFile"
				type="file"
				v-on:click="clearFile"
				v-on:change="selectedFile"
				:accept="fileAcceptExtensions"
			>
		</div>
	</div>
</template>

<script>
import TextInput from '@/components/TextInput.vue';

import { co_isEmpty } from '@/common/checkUtility.js';
import { co_getMessage } from '@/common/messageUtility.js';

import { FILE_SIZE } from '@/const/const.js';
import { STORE_ERROR_IS_ERRFLG, STORE_ERROR_SET_INPUT_ERR, STORE_ERROR_CLEAR } from '@/const/store.js';

export default {
	components: {
		'text-input': TextInput,
	},
	props: {
		name: {type: String, default: ''},							// 項目名
		requireFlg: {type: Boolean, default: false},				// true : 必須
		clickUploadOrSaveBtn: {type: Function, default: function() {
				return null
			}
		},															// 取り込みボタン押下時に呼ばれる関数
		placeholder: { type: String, default: null },				// プレースホルダー
		fileSize: {Number, default: 0},								// ファイルサイズ
		fileExtensions: {type: Array, default: function() {
				return []
			}
		},															// 許可するファイルの拡張子
		fileAcceptExtensions: {type: Array, default: function() {
				return []
			}
		},															// 選択可能とするファイルの拡張子
		messageType: {type: String, default: ''},					// エラーメッセージの引数
		tabindex: {type: String, default: '0'},						// タブインデックス
		groupId: {type: String, default: ''},						// 項目グループID
		classDiv: {type: String, default: ''},						// コントロールエリアのスタイル
	},
	data: function () {
		return {
			hoverFlg: false,
			errorFlg: false,
			file: null,
			fileName: '',
			formData: null,
		}
	},
	created: function() {

	},
	computed: {
		errFlg: function () {
			return this.$store.getters[STORE_ERROR_IS_ERRFLG];
		}
	},
	watch: {
		errFlg: function(newValue) {
			if(newValue === false) {
				this.clearError();
			}
		}
	},
	methods: {
		clickAddBtn: function () {

			// 選択ダイアログ呼び出し
			this.$refs.inputFile.click();
		},
		clickDelBtn: function () {

			// 指定したメッセージを削除
			this.$store.commit(STORE_ERROR_CLEAR);

			// セレクトボックスで選択したファイルを削除
			this.file = null;
			this.fileName = "";

		},
		clearFile: function (event) {
			event.target.value = '';
		},
		selectedFile: function (event) {
			if (!co_isEmpty(event.target.value)) {
				// 選択ダイアログで選択したファイルを取得
				this.file = this.$refs.inputFile.files[0];
				this.fileName = this.file.name;
			}
		},
		createFormData: function ( key ) {

			this.formData = new FormData();
			if ( this.file !== null ) {
				this.formData.append( key, this.file );
			}
		},
		// 妥当性チェック
		validate: function() {

			let error = false;

			// 必須チェック
			if(this.requireFlg === true) {
				if(this.file === null) {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR,
										{id: this.groupId, msg: co_getMessage('E0031')});
					error = true;
				}
			}

			if(this.file !== null) {

				let limit = FILE_SIZE.ONE_MB * this.fileSize

				// ファイル存在チェック
				if (this.file.size == 0) {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR,
										{id: this.groupId, msg: co_getMessage('E0032')});
					error = true;
				}

				// ファイルサイズチェック
				if(limit < this.file.size) {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR,
										{id: this.groupId, msg: co_getMessage('E0033', this.fileName, this.fileSize.toString() + 'MB')});
					error = true;
				}

				// 拡張子チェック
				// ※拡張子の指定があり、かつ、拡張子エラーがない場合のみ
				if (!co_isEmpty(this.fileExtensions)) {
					// ファイル名から拡張子を取得し、比較のため小文字にする
					let ext = this.getExtension(this.fileName).toLowerCase();

					// 許可された拡張子かチェック
					let result = this.fileExtensions.indexOf(ext);
					if(result === -1) {
						this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {id: this.groupId, msg: co_getMessage('E0040')});
						error = true;
					}
				}
			}

			this.errorFlg = error;
			return !this.errorFlg;
		},
		getExtension: function(filename) {

			var pos = filename.lastIndexOf('.');
			if (pos === -1){
				return '';
			}
			return filename.slice(pos + 1);
		},
		getFile: function() {
			return this.file;
		},
		getFormData: function() {
			return this.formData;
		},
		// エラー設定
		setError: function() {
			this.errorFlg = true;
		},
		// エラークリア
		clearError: function() {
			this.errorFlg = false;
		},
		// フォーカス設定
		focus: function() {
			this.$refs.addBtn.focus();
		},
		// 選択済みファイルクリア
		clearSelectedFile() {
			this.file = null;
			this.fileName = "";
		}
	}
}
</script>

<style scoped>
.enter {
	background-color: #e7f5ff !important;
	color: #fff;
}

.none {
	display: none;
}

.div-item--upload__area--float {
	display: inline-block;
}

.div-item--upload input[type='text']:disabled {
	background: #fffffa;
}

.div-item--upload input[type='text']::-ms-expand{
	display: none;
}

.div-item--upload input[type='text'] {
	width: 380px;
}

.contents__btn {
	padding: 0.1em 1.6em;
	margin-left: 10px;
}
.contents__btn--torikomi {
	margin-left: 140px;
}

select {
	-webkit-appearance: none;/* ベンダープレフィックス(Google Chrome、Safari用) */
	-moz-appearance: none; /* ベンダープレフィックス(Firefox用) */
	appearance: none; /* 標準のスタイルを無効にする */
}
::-ms-expand { /* select要素のデザインを無効にする（IE用） */
	display: none;
}

.margin-select-btn {
	margin-left: 9.5px !important;
}

</style>